module.exports = __webpack_public_path__ + "assets/img/home_banner.5a1e7b97.png";